module.exports = __webpack_public_path__ + "img/bt1_act.a6334ec3.png";